module.exports = __webpack_public_path__ + "NanumSquareB.81807f549c75fc3dcde7.eot";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareB.eot
// module id = ../../../../../src/assets/font/NanumSquareB.eot
// module chunks = styles